var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cookie-privacy-settings",on:{"click":function($event){$event.preventDefault();return _vm.showModal($event)}}},[_vm._v(_vm._s(_vm.linkText()))])}
var staticRenderFns = []

export { render, staticRenderFns }